package com.essntl.features.client.ui.allclients

interface AllClientsNavigation {
    data object AddClient : AllClientsNavigation
    data class EditClient(val clientId: String) : AllClientsNavigation
    data object CloseSidePanel : AllClientsNavigation
}